import { render } from "./TemplateContentView.vue?vue&type=template&id=3539a880"
import script from "./TemplateContentView.vue?vue&type=script&lang=js"
export * from "./TemplateContentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__